import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 32px;
  flex-wrap: wrap;
`;

export const RegularLessonsCard = styled.div`
  background: #e9f5ec;
  border-left: 6px solid #4caf50;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 14px rgb(184 151 255 / 26%);
  flex: 1;
  min-width: 320px;
`;

export const TrialLessonsCard = styled.div`
  background: #f3ecff;
  border-left: 6px solid #9c27b0;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 14px rgb(184 151 255 / 26%);
  flex: 1;
  min-width: 320px;
`;

export const BlockTitle = styled.h3`
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin-bottom: 16px;
`;

export const LessonItem = styled.div`
  padding: 16px;
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 14px;
  border: 1px solid #ddd;
  transition: background 0.2s ease;

  &:hover {
    background: #f7f7f7;
  }
`;

export const LessonHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const StudentName = styled.div`
  font-weight: 600;
  font-size: 17px;
  color: #2b2b2b;
`;

export const Time = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #1a73e8;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const Teacher = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
  cursor: pointer;

  &:hover {
    color: #512da8;
  }
`;

export const Tag = styled.span<{ variant: "past" | "future" }>`
  background-color: ${(props) =>
    props.variant === "past" ? "#d1e7dd" : "#fff3cd"};
  color: ${(props) => (props.variant === "past" ? "#0f5132" : "#664d03")};
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 8px;
  font-weight: 500;
`;

export const Filters = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

export const FilterButton = styled.button`
  background: ${(props) => (props.$active ? "#4caf50" : "#fff")};
  color: ${(props) => (props.$active ? "#fff" : "#4caf50")};
  border: 1px solid #4caf50;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background: #4caf50;
    color: #fff;
  }
`;

export const Loading = styled.div`
  font-size: 16px;
  color: #999;
`;

export const NoLessons = styled.div`
  font-size: 16px;
  color: #bbb;
  font-style: italic;
`;


export const MissingLessonsCard = styled.div`
  background: #fff7e6;
  border-left: 6px solid #ff9800;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 14px rgba(255, 193, 7, 0.25);
  flex: 1;
  min-width: 320px;
`;